import type { RfqPackage } from '../types';
import { activeScopeStructures } from './rfqPackageArchivedStructures';

export type RfqPackageScopeFields = Pick<
  RfqPackage,
  'scopeStructures' | 'archivedStructureIds' | 'proposalSnapshot' | 'cncPackagePayload' | 'workType'
>;

/**
 * Structure names the package currently covers. Prefers the explicit
 * {@link RfqPackage.scopeStructures} snapshot; legacy packages fall back to the
 * CNC payload structures, then the timber proposal snapshot's node set names.
 * Empty array = package covers all structures (no scope recorded).
 */
export function packageScopeStructureNames(pkg: RfqPackageScopeFields): string[] {
  if (pkg.scopeStructures?.length) {
    return activeScopeStructures(pkg.scopeStructures, pkg.archivedStructureIds).map(s => s.name).filter(Boolean);
  }
  if (pkg.cncPackagePayload?.structures?.length) {
    return pkg.cncPackagePayload.structures.map(s => s.name).filter(Boolean);
  }
  if ((pkg.workType ?? 'timber_rfq') === 'timber_rfq' && pkg.proposalSnapshot?.nodeSets?.length) {
    return pkg.proposalSnapshot.nodeSets.map(ns => ns.name).filter(Boolean);
  }
  return [];
}
